import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { RoutingService } from './routing.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class LayoutService implements OnDestroy {
  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly platform: Platform,
    private routingService: RoutingService,
    private readonly spinnerService: NgxSpinnerService
  ) {
    this.subscriptions = this.viewForTablet$.subscribe((isTablet) => {
      if (isTablet) {
        this.closeSideNav();
      } else {
        this.openSideNav();
      }
    });
    this.pageTitle$ = routingService.getRouteData<string>('pageTitle');
  }

  subscriptions: Subscription;

  pageTitle$: Observable<string>;
  viewForDesktop$ = this.breakpointObserver
    .observe(`(min-width: 1280px)`)
    .pipe(map((state) => state.matches));

  viewForTablet$ = this.viewForDesktop$.pipe(
    map((isDesktop) => !isDesktop || this.isOnTablet)
  );
  readonly isOnTablet = this.platform.IOS || this.platform.ANDROID;

  sideNavMode$ = this.viewForTablet$.pipe(
    map((isForTablet) => (isForTablet ? 'over' : 'side'))
  );

  private _sideNavOpen = new BehaviorSubject<boolean>(!this.isOnTablet);
  sideNavOpen$ = this._sideNavOpen.asObservable();

  private loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  openSideNav(): void {
    this._sideNavOpen.next(true);
  }

  closeSideNav(): void {
    this._sideNavOpen.next(false);
  }

  reverseSideNavChange(): void {
    this._sideNavOpen.next(!this._sideNavOpen.value);
  }

  setLoading(loading: boolean): void {
    (loading ? this.spinnerService.show() : this.spinnerService.hide()).then(
      () => {
        this.loading.next(loading);
      }
    );
  }
}
